module.exports = __webpack_public_path__ + "static/media/to-legends.d749f627.jpg";